// Neutral SaaS product identity (no shop-specific business info on public pages).
export const BUSINESS = {
  product: "PartVision AI",
  tagline: "AI-Powered Visual Spare Parts Finder",
  dataset_tagline: "AI-Powered Mahindra Tractor Parts Finder",
  support_email: "sparepartslens@gmail.com",
};
